var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import { Form, Input } from 'antd';
import Dimio, { FormComponent } from './Dimio';
import config from './config';

/**
 * @params
 *   url
 *   handleSubmit
 *   core(*)
 */

var SigninFormBase = function (_FormComponent) {
  _inherits(SigninFormBase, _FormComponent);

  function SigninFormBase(props) {
    _classCallCheck(this, SigninFormBase);

    var _this = _possibleConstructorReturn(this, (SigninFormBase.__proto__ || Object.getPrototypeOf(SigninFormBase)).call(this, props));

    _this.state = {
      token: null
    };

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  _createClass(SigninFormBase, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          url = _props.url,
          token = _props.token,
          onSubmit = _props.onSubmit,
          onError = _props.onError;

      var self = this;
      /*
          if(!url){
            throw 'url is not defined';
          }
          */
      if (!onSubmit) {
        throw 'onSubmit is not defined';
      }
      if (!onError) {
        throw 'onError is not defined';
      }

      if (token) {
        Dimio.load(token, {}, { checkSuccess: false }).then(function (res) {
          console.info('init', res);
          self.setState({ token: res });
        }).catch(function (e) {
          console.info(e);
          onError(e);
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          form = _props2.form,
          defaultValues = _props2.defaultValues;

      console.info(defaultValues);
      form.setFieldsValue(defaultValues);
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      var _props3 = this.props,
          form = _props3.form,
          url = _props3.url,
          onSubmit = _props3.onSubmit,
          onError = _props3.onError;
      var token = this.state.token;

      console.info(token);

      form.validateFieldsAndScroll(function (err, values) {
        if (!err) {
          if (url) {
            Dimio.save(url, values, { token: token }).then(function (res) {
              onSubmit(res);
            }).catch(function (e) {
              onError(e);
            });
          } else {
            onSubmit(values);
          }
        } else {
          onError(err);
          //        console.info(err);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var buttonLabel = this.props.buttonLabel;
      var fields = config.signin.fields;


      var Field = this.Field;
      var Submit = this.Submit;

      return React.createElement(
        Form,
        {
          className: 'dimio-form-signin',
          layout: 'vertical',
          onSubmit: this.handleSubmit },
        React.createElement(
          Field,
          fields.email,
          React.createElement(Input, null)
        ),
        React.createElement(
          Field,
          fields.password,
          React.createElement(Input, { type: 'password' })
        ),
        React.createElement(
          Submit,
          null,
          buttonLabel
        )
      );
    }
  }]);

  return SigninFormBase;
}(FormComponent);

export var SigninForm = Form.create()(SigninFormBase);


//////////////////
// WEBPACK FOOTER
// ./node_modules/dimio/dist/DimioForms.js
// module id = 1336
// module chunks = 0